// The API serializes enums as their C# member names (JsonStringEnumConverter),
// so these values are the strings that actually arrive over the wire.
export enum MeterRatingUnits {
  A = 'A',
}

export enum MeterRatingIdType {
  CustomerMeter = 'CustomerMeter',
  AssetMeter = 'AssetMeter',
}

export const meterRatingUnitLabels: Record<string, string> = {
  [MeterRatingUnits.A]: 'A',
};

export const meterRatingIdLabels: Record<string, string> = {
  [MeterRatingIdType.CustomerMeter]: 'Customer Meter',
  [MeterRatingIdType.AssetMeter]: 'Asset Meter',
};

export const meterRatingIdOptions = Object.values(MeterRatingIdType).map(
  (id) => ({ id, name: meterRatingIdLabels[id] })
);

export class MeterRating {
  id: number;
  rating: string;
  unit?: MeterRatingUnits;
  meterRatingId?: MeterRatingIdType;
  meterBrandIds: number[];
  dtMeterTypeIds: number[];

  constructor(data?: any) {
    this.id = data?.id ?? 0;
    this.rating = data?.rating ?? '';
    this.unit = data?.unit ?? undefined;
    this.meterRatingId = data?.meterRatingId ?? undefined;
    this.meterBrandIds = data?.meterBrandIds ?? [];
    this.dtMeterTypeIds = data?.dtMeterTypeIds ?? [];
  }

  get unitLabel(): string {
    return this.unit == null ? '' : meterRatingUnitLabels[this.unit] ?? '';
  }

  get ratingDisplay(): string {
    return [this.rating, this.unitLabel].filter((part) => !!part).join(' ');
  }

  get meterRatingIdLabel(): string {
    return this.meterRatingId == null
      ? ''
      : meterRatingIdLabels[this.meterRatingId] ?? '';
  }
}

export class MeterRatingSaveDto {
  id: number | null;
  rating: string;
  unit: string;
  meterRatingId?: MeterRatingIdType;
  meterBrandIds: number[];
  dtMeterTypeIds: number[];

  constructor(data?: Partial<MeterRatingSaveDto>) {
    this.id = data?.id ?? null;
    this.rating = data?.rating ?? '';
    this.unit = data?.unit ?? '';
    this.meterRatingId = data?.meterRatingId;
    this.meterBrandIds = data?.meterBrandIds ?? [];
    this.dtMeterTypeIds = data?.dtMeterTypeIds ?? [];
  }
}
